module.exports = __webpack_public_path__ + "img/logo_afps.0cbd2659.png";